import { isEmpty } from "lodash/fp"

import { isValidLocation } from "../../../helpers/validators"

import GradeDropdown from "../GradeDropdown"
import MultipleProgramsDropdown from "../MultipleProgramsDropdown"
import StruggleWithDropdown from "../StruggleWithDropdown"
import SpecialTreatmentDropdown from "../SpecialTreatmentDropdown"
import LocationDropdown from "../LocationDropdown"
import {
  getLabelByValue,
  getProgramsSummary,
  getSpecialTreatmentsSummary,
  getLocationSummary,
  getStruggleWithSummary,
  getPriceSummary,
} from "../../../helpers/presentational"
import WizardGradeStep from "../wizard/WizardGradeStep"
import WizardProgramStep from "../wizard/WizardProgramStep"
import WizardSpecialTreatmentStep from "../wizard/WizardSpecialTreatmentStep"
import SimplePriceDropdown from "../SimplePriceDropdown"

export default [
  // Grade
  {
    id: "grade",
    getButtonText: (value, options) => getLabelByValue(options.grades)(value) || "Pick a grade",
    fieldsToReset: ["program_ids", "struggle_with"],
    FilterComponent: GradeDropdown,
    FilterComponentProps: {},
    WizardComponent: WizardGradeStep,
    WizardComponentProps: {
      title: "What grade is your child in?",
    },
    disabled: () => false,
    completed: ({ grade }) => !!grade,
  },
  // Subject
  {
    id: "program_ids",
    getButtonText: (value, options) =>
      value && value.length > 0 ? getProgramsSummary(value[0], options.programs) : "Pick a subject",
    fieldsToReset: ["struggle_with"],
    FilterComponent: MultipleProgramsDropdown,
    FilterComponentProps: {},
    WizardComponent: WizardProgramStep,
    WizardComponentProps: {
      title: "What does your child need support with?",
    },
    disabled: ({ grade }) => !grade,
    completed: ({ program_ids }) => !!program_ids && program_ids.length > 0,
  },
  // Struggles with
  {
    id: "struggle_with",
    getButtonText: (value, options) => getStruggleWithSummary(value, options) || "Specific struggles",
    fieldsToReset: [],
    FilterComponent: StruggleWithDropdown,
    FilterComponentProps: { optionType: "checkbox" },
    disabled: ({ grade, program_ids }) => !grade || !program_ids || !program_ids.length,
    completed: ({ struggle_with }) => !isEmpty(struggle_with),
  },
  // Learning differences (former Special treatments, disabilities)
  {
    id: "special_treatments",
    getButtonText: (values, options) =>
      getSpecialTreatmentsSummary(values, options) || "Diagnosed learning difference?",
    fieldsToReset: [],
    FilterComponent: SpecialTreatmentDropdown,
    FilterComponentProps: { optionType: "checkbox" },
    WizardComponent: WizardSpecialTreatmentStep,
    WizardComponentProps: {
      title: "Does your child have a learning difference?",
      nextButtonText: "Continue",
      skipButtonText: "No learning difference",
    },
    disabled: () => false,
    completed: ({ special_treatments, executive_function }) => !isEmpty(special_treatments) || executive_function,
  },
  // // Location
  {
    id: "location",
    getButtonText: values => getLocationSummary(values) || "Location / Online",
    fieldsToReset: [],
    FilterComponent: LocationDropdown,
    FilterComponentProps: {
      submitButtonText: "Continue",
    },
    disabled: () => false,
    completed: ({ online, offline, zip }) => online || isValidLocation({ offline, zip }),
  },
  // Price
  {
    id: "price",
    name: "Price",
    getButtonText: value => getPriceSummary(value),
    fieldsToReset: [],
    FilterComponent: SimplePriceDropdown,
    FilterComponentProps: {},
    WizardComponent: null,
    hideOnMobile: true,
    disabled: () => false,
    completed: ({ max_price, min_price }) => !!min_price || !!max_price,
  },
]
